


import React from 'react'
import './Internship.css'





const Internship:React.FC = () => {



  return (
        <>

        <div className=' w-screen overflow-hidden p-10 custom-internship-container'>
            <div className=' flex flex-col items-center justify-center mx-auto max-w-[800px]'>
                <div className=' sm:text-lg md:text-xl lg:text-3xl xl:text-4xl  text-black font-sans '>
                    <h3>Internship & Career Opportunities</h3>
                    </div>

                    <div className=' sm:text-lg md:text-lg lg:text-lg xl:text-lg  text-black text-center font-mono w-[80%] mt-10'>
                        <p>We offer internships in marketing, operations, 
                            recruiting, coaching, and media. Ideal for students and young professionals
                             seeking real-world experience.</p>
                    </div>

            </div>
        </div>
 
 
 
 
 
        </>    
  )
}




export default Internship
